import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	googleDocsLabel: {
		id: 'document-search-result.google-docs-label',
		defaultMessage: 'Docs',
		description: 'Google Docs subtype label',
	},
	googleSlidesLabel: {
		id: 'document-search-result.google-slides-label',
		defaultMessage: 'Slides',
		description: 'Google Slides subtype label',
	},
	googleSheetsLabel: {
		id: 'document-search-result.google-sheets-label',
		defaultMessage: 'Sheets',
		description: 'Google Sheets subtype label',
	},
	msWordLabel: {
		id: 'document-search-result.ms-word-label',
		defaultMessage: 'Word',
		description: 'Microsoft Word subtype label',
	},
	msPowerpointLabel: {
		id: 'document-search-result.ms-powerpoint-label',
		defaultMessage: 'PowerPoint',
		description: 'Microsoft PowerPoint subtype label',
	},
	msExcelLabel: {
		id: 'document-search-result.ms-excel-label',
		defaultMessage: 'Excel',
		description: 'Microsoft Excel subtype label',
	},

	documentLabel: {
		id: 'document.label',
		defaultMessage: 'Document',
		description: 'Document subtype label',
	},
	spreadsheetLabel: {
		id: 'spreadsheet.label',
		defaultMessage: 'Spreadsheet',
		description: 'Spreadsheet subtype label',
	},
	presentationLabel: {
		id: 'presentation.label',
		defaultMessage: 'Presentation',
		description: 'Presentation subtype label',
	},
	fileLabel: {
		id: 'file.label',
		defaultMessage: 'File',
		description: 'File subtype label',
	},
	databaseLabel: {
		id: 'database.label',
		defaultMessage: 'Database',
		description: 'Database subtype label',
	},
	webPageLabel: {
		id: 'web-page.label',
		defaultMessage: 'Web Page',
		description: 'Web Page subtype label',
	},
	pageLabel: {
		id: 'page.label',
		defaultMessage: 'Page',
		description: 'Page subtype label',
	},
	blogpostLabel: {
		id: 'blogpost.label',
		defaultMessage: 'Blogpost',
		description: 'Blogpost subtype label',
	},
	dashboardLabel: {
		id: 'dashboard.label',
		defaultMessage: 'Dashboard',
		description: 'Dashboard subtype label',
	},
	invoiceLabel: {
		id: 'invoice.label',
		defaultMessage: 'Invoice',
		description: 'Invoice subtype label',
	},
	designLabel: {
		id: 'design.label',
		defaultMessage: 'Design',
		description: 'Design subtype label',
	},
	dealLabel: {
		id: 'deal.label',
		defaultMessage: 'Deal',
		description: 'Deal subtype label',
	},
	videoLabel: {
		id: 'video.label',
		defaultMessage: 'Video',
		description: 'Video subtype label',
	},
	taskLabel: {
		id: 'task.label',
		defaultMessage: 'Task',
		description: 'Task subtype label',
	},
	issueLabel: {
		id: 'issue.label',
		defaultMessage: 'Issue',
		description: 'Issue subtype label',
	},
	spaceLabel: {
		id: 'space.label',
		defaultMessage: 'Space',
		description: 'Space subtype label',
	},
	projectLabel: {
		id: 'project.label',
		defaultMessage: 'Project',
		description: 'Project subtype label',
	},
	repositoryLabel: {
		id: 'repository.label',
		defaultMessage: 'Repository',
		description: 'Repository subtype label',
	},
	branchLabel: {
		id: 'branch.label',
		defaultMessage: 'Branch',
		description: 'Branch subtype label',
	},
	commitLabel: {
		id: 'commit.label',
		defaultMessage: 'Commit',
		description: 'Commit subtype label',
	},
	pullRequestLabel: {
		id: 'pull-request.label',
		defaultMessage: 'Pull Request',
		description: 'Pull Request subtype label',
	},
	customerOrgLabel: {
		id: 'customer-org.label',
		defaultMessage: 'Customer Org',
		description: 'Customer Org subtype label',
	},
	imageLabel: {
		id: 'image.label',
		defaultMessage: 'Image',
		description: 'Image subtype label',
	},
	archiveLabel: {
		id: 'archive.label',
		defaultMessage: 'Archive',
		description: 'Archive subtype label',
	},
	audioLabel: {
		id: 'audio.label',
		defaultMessage: 'Audio',
		description: 'Audio subtype label',
	},
	pdfLabel: {
		id: 'pdf.label',
		defaultMessage: 'PDF',
		description: 'PDF subtype label',
	},
	codeLabel: {
		id: 'code.label',
		defaultMessage: 'Code',
		description: 'Code subtype label',
	},
	channelLabel: {
		id: 'channel.label',
		defaultMessage: 'Channel',
		description: 'Channel subtype label',
	},
	otherLabel: {
		id: 'other.label',
		defaultMessage: 'Other',
		description: 'Other subtype label',
	},
});
